import axios from "axios";
import get from "lodash/get";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  getBookingsByParams,
  getBookingsyncConversation,
  searchProperties
} from "../../services/api";
import Search from "./Search.js";

export default function SearchContainer() {
  const [state, setState] = useState({
    loading: true,
    error: false,
    data: null,
    bookingsyncConversation: null
  });

  const {
    guestEmail,
    conversationId,
    vrboListingId,
    expediaListingId,
    platformRef
  } = useParams();
  const navigate = useNavigate();
  const cancelRequestRef = useRef(null);

  const getSearchResults = useCallback(() => {
    cancelRequestRef.current = axios.CancelToken.source();
    setState(prevState => ({ ...prevState, loading: true }));

    let getData;
    if (guestEmail || platformRef) {
      getData = getBookingsByParams;
    } else if (vrboListingId || expediaListingId) {
      getData = searchProperties;
    }

    if (getData) {
      getData(
        {
          guest_email: guestEmail,
          platform_ref: platformRef,
          vrbo_listing_id: vrboListingId,
          expedia_listing_id: expediaListingId
        },
        cancelRequestRef.current.token
      )
        .then(({ data }) => {
          setState(prevState => ({
            ...prevState,
            data: data,
            loading: !!conversationId
          }));
          if (conversationId) {
            getBookingsyncConversation(
              conversationId,
              cancelRequestRef.current.token
            ).then(({ data: bookingsyncConversation }) => {
              setState(prevState => ({
                ...prevState,
                bookingsyncConversation,
                loading: false
              }));
            });
          }
        })
        .catch(error => {
          if (get(error, "response.data.status_code", null) === 404) {
            return navigate("/not-found");
          }

          if (axios.isCancel(error)) {
            return console.info(error.message);
          }

          setState(prevState => ({
            ...prevState,
            loading: false,
            error
          }));
        });
    }
  }, [
    guestEmail,
    platformRef,
    vrboListingId,
    expediaListingId,
    navigate,
    conversationId
  ]);

  useEffect(() => {
    getSearchResults();

    return () => {
      cancelPendingRequest(
        "This request was pending after the component unmounted."
      );
    };
  }, [
    guestEmail,
    conversationId,
    vrboListingId,
    expediaListingId,
    platformRef,
    getSearchResults
  ]);

  const cancelPendingRequest = message => {
    if (cancelRequestRef.current) {
      cancelRequestRef.current.cancel(message);
      cancelRequestRef.current = null;
    }
  };

  const updateThread = () => {
    if (conversationId) {
      getBookingsyncConversation(
        conversationId,
        cancelRequestRef.current.token
      ).then(({ data: bookingsyncConversation }) => {
        setState(prevState => ({
          ...prevState,
          bookingsyncConversation
        }));
      });
    }
  };

  return (
    <React.Fragment>
      <Search state={state} update={updateThread} />
    </React.Fragment>
  );
}
